import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  BufferOverflow_SUSPEND_instance = new (BufferOverflow())('SUSPEND', 0);
  BufferOverflow_DROP_OLDEST_instance = new (BufferOverflow())('DROP_OLDEST', 1);
  BufferOverflow_DROP_LATEST_instance = new (BufferOverflow())('DROP_LATEST', 2);
}
var BufferOverflow_SUSPEND_instance;
var BufferOverflow_DROP_OLDEST_instance;
var BufferOverflow_DROP_LATEST_instance;
var BufferOverflowClass;
function BufferOverflow() {
  if (BufferOverflowClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'BufferOverflow');
    BufferOverflowClass = $;
  }
  return BufferOverflowClass;
}
function BufferOverflow_SUSPEND_getInstance() {
  static_init();
  return BufferOverflow_SUSPEND_instance;
}
function BufferOverflow_DROP_OLDEST_getInstance() {
  static_init();
  return BufferOverflow_DROP_OLDEST_instance;
}
function BufferOverflow_DROP_LATEST_getInstance() {
  static_init();
  return BufferOverflow_DROP_LATEST_instance;
}
//region block: exports
export {
  BufferOverflow_DROP_LATEST_getInstance as BufferOverflow_DROP_LATEST_getInstancemfonw00bpn5q,
  BufferOverflow_DROP_OLDEST_getInstance as BufferOverflow_DROP_OLDEST_getInstance2xuwx7fze5aij,
  BufferOverflow_SUSPEND_getInstance as BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2,
};
//endregion

//# sourceMappingURL=BufferOverflow.mjs.map
